module.exports = require('./_global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_html.js
 ** module id = 1001
 ** module chunks = 1
 **/